import {
  useRoutes,
  Navigate,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Routes,
} from "react-router-dom";
import {
  PieChartOutlined,
  SecurityScanOutlined,
  SettingOutlined,
  FolderOpenOutlined,
  ProjectOutlined,
  TeamOutlined,
  ProfileOutlined,
  BarChartOutlined,
  AuditOutlined,
} from "@ant-design/icons";
import Root from "@/views";

const normalRoutes = [
  {
    path: "/login",
    lazy: async () => ({ Component: (await import("@/views/login")).default }),
  },
  {
    path: "/",
    element: <Root />,
    // lazy: async () => ({Component:(await import("@/views")).default}),
  },
  {
    path: "*",
    lazy: async () => ({
      Component: (await import("@/views/notFund")).default,
    }),
  },
];

const AdminRoutes: any = {
  path: "/",
  element: <Root />,
  // children:[
  //   {
  //     key:'social_media_search_word_zhihu',
  //     path: '/dashbord',
  //     label:'数据看板',
  //     lazy: async () => ({Component:(await import("@/views/zhihu")).default}),
  //   }
  // ]
};
export const moudleRoutes: any = [
  {
    key: "task",
    path: "/task",
    label: "任务列表",
    icon: <ProjectOutlined />,
    lazy: async () => ({ Component: (await import("@/views/task")).default }),
  },
  {
    key: "audit",
    path: "/audit",
    label: "审核管理",
    icon: <AuditOutlined />,
    // lazy: async () => ({Component:(await import("@/views/audit")).default}),
    children: [
      // {
      //   key: "audit_agent",
      //   path: "/audit/agent",
      //   label: "代理审核",
      //   icon: <ProjectOutlined />,
      //   lazy: async () => ({
      //     Component: (await import("@/views/audit/agent")).default,
      //   }),
      // },
      {
        key: "audit_brand",
        path: "/audit/brand",
        label: "品牌审核",
        icon: <ProjectOutlined />,
        lazy: async () => ({
          Component: (await import("@/views/audit/brand")).default,
        }),
      },
      {
        key: "audit_rejected",
        path: "/audit/rejected",
        label: "驳回已处理",
        icon: <ProjectOutlined />,
        lazy: async () => ({
          Component: (await import("@/views/audit/rejected")).default,
        }),
      },
      {
        key: "audit_unrejected",
        path: "/audit/unrejected",
        label: "驳回未处理",
        icon: <ProjectOutlined />,
        lazy: async () => ({
          Component: (await import("@/views/audit/un-rejected")).default,
        }),
      },
      {
        key: "audit_confirm",
        path: "/audit/confirm",
        label: "已确认",
        icon: <ProjectOutlined />,
        lazy: async () => ({
          Component: (await import("@/views/audit/confirm")).default,
        }),
      },
      {
        key: "audit_expirated",
        path: "/audit/expirated",
        label: "已过期",
        icon: <ProjectOutlined />,
        lazy: async () => ({
          Component: (await import("@/views/audit/expirated")).default,
        }),
      },
      {
        key: "audit_unqualified",
        path: "/audit/unqualified",
        label: "不合格",
        icon: <ProjectOutlined />,
        lazy: async () => ({
          Component: (await import("@/views/audit/un-qualified")).default,
        }),
      },
    ],
  },
  {
    key: "statistics",
    path: "/statistics",
    label: "平台统计",
    icon: <BarChartOutlined />,
    lazy: async () => ({
      Component: (await import("@/views/platform")).default,
    }),
  },
  {
    key: "task_create",
    path: "/task/create",
    label: "创建任务",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/task/create")).default,
    }),
  },
  {
    key: "task_create_batch",
    path: "/task/batch",
    label: "批量任务",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/task/batch")).default,
    }),
  },
  {
    key: "task_id",
    path: "/task/:id",
    label: "任务",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/task/:id")).default,
    }),
  },

  {
    key: "employee",
    path: "/employee",
    label: "员工列表",
    icon: <TeamOutlined />,
    lazy: async () => ({
      Component: (await import("@/views/employee")).default,
    }),
  },
  {
    key: "employee_create",
    path: "/employee/create",
    label: "员工",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/employee/create")).default,
    }),
  },
  {
    key: "employee_statistics",
    path: "/employee/charts",
    label: "员工统计",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/employee/charts")).default,
    }),
  },
  {
    key: "employee_id",
    path: "/employee/:id",
    label: "员工",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/employee/:id")).default,
    }),
  },

  {
    key: "folders",
    path: "/folders",
    label: "文件夹管理",
    icon: <FolderOpenOutlined />,
    lazy: async () => ({ Component: (await import("@/views/folder")).default }),
  },
  {
    key: "articles",
    path: "/articles",
    label: "文章管理",
    icon: <ProfileOutlined />,
    lazy: async () => ({
      Component: (await import("@/views/articles")).default,
    }),
  },
  {
    key: "articles_create",
    path: "/articles/create",
    label: "文章",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/articles/create")).default,
    }),
  },
  {
    key: "articles_id",
    path: "/articles/:id",
    label: "文章",
    hide: true,
    lazy: async () => ({
      Component: (await import("@/views/articles/:id")).default,
    }),
  },
  {
    key: "setting",
    path: "/setting",
    label: "账号管理",
    icon: <SettingOutlined />,
    lazy: async () => ({
      Component: (await import("@/views/setting")).default,
    }),
  },
  {
    key: "white-user",
    path: "/white-user",
    label: "白名单管理",
    icon: <SecurityScanOutlined />,
    lazy: async () => ({
      Component: (await import("@/views/white-user")).default,
    }),
  },
  {
    key: "setting-info",
    path: "/setting/info",
    label: "账号设置",
    hide: true,

    lazy: async () => ({
      Component: (await import("@/views/setting/info")).default,
    }),
    // children:[
    //   {
    //     key:'setting_article',
    //     path: '/setting',
    //     label:'账号列表',
    //     lazy: async () => ({Component:(await import("@/views/setting")).default}),
    //   },
    //   {
    //     key:'setting_article',
    //     path: '/setting/info',
    //     label:'账号设置',
    //     lazy: async () => ({Component:(await import("@/views/setting/info")).default}),
    //   },

    // ]
  },
];
// export default createBrowserRouter(routes);

AdminRoutes.children = [...moudleRoutes];
normalRoutes.push(AdminRoutes);
export default normalRoutes;
